export default __webpack_public_path__ + "static/media/DTE.ccd4babb.png";